import { createContext, useContext, useEffect, useState } from "react";
import {
	getSession,
	onAuthChange,
	getAdminProfile,
	signOut as supabaseSignOut,
} from "../lib/supabase";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
	const [session, setSession] = useState(null);
	const [adminProfile, setAdminProfile] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const loadProfile = async (userId) => {
		console.log("[AdminAuth] loadProfile userId:", userId);
		if (!userId) {
			setAdminProfile(null);
			return;
		}
		const { data, error } = await getAdminProfile();
		console.log(
			"[AdminAuth] Retour getAdminProfile — data:",
			data,
			"error:",
			error,
		);
		if (error || !data) {
			setAdminProfile(null);
			return;
		}
		setAdminProfile(data);
		console.log("[AdminAuth] adminProfile SET:", data);
	};

	useEffect(() => {
		let mounted = true;
		console.log("[AdminAuth] Provider monté");

		(async () => {
			const {
				data: { session: initialSession },
			} = await getSession();
			console.log(
				"[AdminAuth] Session initiale user:",
				initialSession?.user?.id,
			);
			if (!mounted) return;
			setSession(initialSession);
			await loadProfile(initialSession?.user?.id);
			setIsLoading(false);
			console.log("[AdminAuth] Init terminée, isLoading=false");
		})();

		const { data } = onAuthChange(async (event, newSession) => {
			console.log(
				"[AdminAuth] Auth event:",
				event,
				"user:",
				newSession?.user?.id,
			);
			if (!mounted) return;
			setSession(newSession);
			await loadProfile(newSession?.user?.id);
		});

		return () => {
			mounted = false;
			data?.subscription?.unsubscribe();
		};
	}, []);

	const logout = async () => {
		await supabaseSignOut();
		setSession(null);
		setAdminProfile(null);
	};

	const isAuthenticated = !!session && !!adminProfile;
	console.log(
		"[AdminAuth] Render — session:",
		!!session,
		"profile:",
		!!adminProfile,
		"isAuthenticated:",
		isAuthenticated,
		"isLoading:",
		isLoading,
	);

	return (
		<AdminAuthContext.Provider
			value={{
				session,
				adminProfile,
				isLoading,
				isAuthenticated,
				isSuperAdmin: adminProfile?.role === "super_admin",
				logout,
			}}
		>
			{children}
		</AdminAuthContext.Provider>
	);
};

export const useAdminAuth = () => {
	const ctx = useContext(AdminAuthContext);
	if (!ctx)
		throw new Error("useAdminAuth must be used inside AdminAuthProvider");
	return ctx;
};
